import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesProjectService {
  someDataObservable: Observable<any>;
  private uri = "";//`${environment.apiUrl}`;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  GetSalesProject(model) {
    return this.http.post<any>(this.uri + '/ProjectSales/GetSalesProjectPage/', model);
  }

  DeleteSalesProject(id) {
    return this.http.post<any>(this.uri + '/ProjectSales/DeleteSalesProject/', { projectid: id });
  }

  DuplicateProject(id) {
    return this.http.post<any>(this.uri + '/Project/DuplicateProject/', { projectid: id });

  }

  GetEmployeesNoSales() {
    return this.http.post<any>(this.uri + '/Employee/GetEmployeesNoSales', {});
  }

  UpdateEmployeeToSales(id) {
    return this.http.post<any>(this.uri + '/Employee/UpdateEmployeeToSales', { employeeid: id });
  }

  GetSalesProjectUrl() {
    return this.uri + '/ProjectSales/GetSalesProjectPage';
  }


  GetProjectSaleEmployee() {
    return this.http.post<any>(this.uri + '/ProjectSaleEmployee/', {});
  }


  GetProjectBidStatus() {
    return this.http.post<any>(this.uri + '/ProjectBidStatus/', {});
  }

  GetProjectSalesCategory() {
    return this.http.post<any>(this.uri + '/ProjectSalesCategory/', {});
  }

  GetProjectCategoryServicesContract() {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Estimates_Get_ProjectSalesCategory',
      });
  }

  InsertUpdateSalesCategory(model) {
    return this.http.post<any>(this.uri + '/ProjectSalesCategory/InsertUpdateSalesCategory/', model);
  }

  InsertUpdateVerticalMarket(model) {
    return this.http.post<any>(this.uri + '/VerticalMarket/InsertUpdateVerticalMarket/', model);
  }

  InsertUpdateSalesProject(model) {
    // return this.http.post<any>(this.uri + '/ProjectSales/InsertUpateProjectSales', model);
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  Get_SalesProject_All(date:Date) {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_SalesProject_All',
        biddate:date
      });
  }
  Get_ProjectBidStatus() {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Estimates_Get_ProjectBidStatus',
      });
  }

  Update_ProjectChangeStatus(id, bidestatus):Observable<any> {
    if (this.someDataObservable) {
      return this.someDataObservable;
    } else {
      return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Update_ProjectChangeStatus',
        bidstatusid: bidestatus,
        projectid: id
      }); 
    } 
   
  }

  Get_SalesProject_Pagination(filter) {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_SalesProject_Pagination',
        bidstatus: filter.bidstatus,
        pageindex: filter.pageindex,
        pagesize: filter.pagesize
      });
  }
  UpdateProjectBidDate(projectid, biddate) {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Update_ProjectBidDate',
        biddate: biddate,
        projectid: projectid
      });
  }
  /**
   * Get SalesPerson
   */
  GetSalesPerson() {
    return this.http.post(this.uri + '/SalesPerson', {});
  }
  /**
   * New SalesLeads
   * @param data
   */
  newSalesLeads(data) {
    return this.http.post<any>(this.uri + '/SalesLead/InsertUpateSalesLead', data);
  }

  GetProjectParticipant(id) {
    return this.http.post<any>(this.uri + '/ProjectParticipant', { id: id });
  }

  DeleteParticipant(id, projectid){
    //console.log({method:'Delete_ProjectEmployeesCE', id: id});
    return this.http.post<any>(this.uri + '/FlexIntegration',{method:'Delete_ProjectEmployeesCE', id: id})
  }

  InsertProjectParticipant(model) {
    return this.http.post<any>(this.uri + '/ProjectParticipant/InsertUpdateProjectParticipant', model);
  }

  GetProjectParticipantRole() {

    return this.http.post<any>(this.uri + '/ProjectParticipantRole/', {});
  }

  //Documents

  GetDocuments(id, method){
    //console.log({ [method.name_id]: id, method: method.method });
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: method.method, [method.name_id]: id });
  }

  GetDocumentsTwoParameters(id, method, id2){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: method.method, [method.name_id]: id, [method.name_id2]: id2 });
  }

  InsertDocuments(form){
    //console.log(form);
    return this.http.post<any>(this.uri + '/FlexIntegration', form);
  }

  CheckFileExist(filestring){
    return this.http.post<any>(this.uri + '/DownloadFile/CheckFileExist', { filestring: filestring });
  } 

  GetProjectDocument(projectid) {
    return this.http.post<any>(this.uri + '/ProjectDocument', { projectid: projectid });
  }

  GetProjectDocumentType() {
    return this.http.post<any>(this.uri + '/DocumentType', {});
  }

  GetProjectDocumentPartsType(){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method:'Get_GetPartDocumentTypes'});
  }

  GetProjectDocumentEditEmployeeDocumentType(){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method:'Get_EmployeeDocumentType'});
  }

  GetProjectNotBidReason() {
    return this.http.post<any>(this.uri + '/ProjectNotBidReason', {});
  }

  GetClientCompetitor() {
    return this.http.post<any>(this.uri + '/ClientCompetitor', {});
  }

  GetProjectActivity(projectid) {
    return this.http.post<any>(this.uri + '/Activity/GetActivityListByProject', { projectid: projectid });
  }

  GetSalesLeadMarketingCampaign() {
    return this.http.post<any>(this.uri + '/SalesLeadMarketingCampaign', {});
  }

  GetProjectVerticalMarket() {
    return this.http.post<any>(this.uri + '/VerticalMarket', {});
  }

  GetPrevailingWages() {
    return this.http.post<any>(this.uri + '/PrevailingWages', {});
  }

  InsertUpdateActivity(model) {
    console.log(model);
    return this.http.post<any>(this.uri + '/Activity/InsertUpdateActivity', model);
  }

  updateTurnOverSheet(obj){
    //console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  getTurnOverSheet(obj){
    //console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetProjectRound(projectid) {
    return this.http.post<any>(this.uri + '/ProjectRound', { id: projectid });
  }

  InsertUpdateProjectRound(model) {
    return this.http.post<any>(this.uri + '/ProjectRound/InsertUpdateProjectRound', model);
  }

  InsertUpateProjectDocument(model) {
    return this.http.post<any>(this.uri + '/ProjectDocument/InsertUpateProjectDocument', model);
  }

  SaveDocument(filename, file, id){
    //console.log({ filename: filename, filestring: file, doctype: 'swodocs', id: id })
    return this.http.post(this.uri + '/DownloadFile/Upload', { filename: filename, filestring: file, doctype: 'swodocs', id: id })
  }

  SaveDocumentDinamico(filename, file, id,doctype){
    console.log('DATA ', {filestring: file, doctype: doctype, id: id })
    return this.http.post(this.uri + '/DownloadFile/Upload', { filestring: file, doctype: doctype, id: id })
  }

  GeneralService(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }
}
